import React from "react";
import Title from "../layouts/Title";
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

// Swiper v11+ correct imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectCoverflow } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "./project.css";

const Projects = () => {
  const projects = [
    {
      title: (
        <a href="https://covidgeo.netlify.app" target="_blank" rel="noreferrer">
          API BASED WEBSITE
        </a>
      ),
      des: "An API-based React + Bootstrap website showing daily weather and COVID-19 tracker data.",
      src: projectOne,
      github: "https://github.com/yourusername/covidgeo",
      live: "https://covidgeo.netlify.app"
    },
    {
      title: "E-commerce Website",
      des: "E-commerce site built using React.js, Bootstrap, and backend integration.",
      src: projectTwo,
      github: "https://github.com/yourusername/ecommerce",
      live: "https://yourecommerce.com"
    },
    {
      title: (
        <a href="https://tvflex.netlify.app/" target="_blank" rel="noreferrer">
          MOVIES WEBSITE
        </a>
      ),
      des: "A React-based movies platform featuring responsive design and animations.",
      src: projectThree,
      github: "https://github.com/yourusername/movies-website",
      live: "https://tvflex.netlify.app/"
    },
    // Duplicate existing projects for demo (remove these if you don't want duplicates)
    {
      title: "Portfolio Website",
      des: "Modern portfolio website with smooth animations and dark theme.",
      src: projectOne, // Using existing image
      github: "https://github.com/yourusername/portfolio",
      live: "https://yourportfolio.com"
    },
    {
      title: "Task Management App",
      des: "Full-stack task management application with real-time updates.",
      src: projectTwo, // Using existing image
      github: "https://github.com/yourusername/task-app",
      live: "https://yourtaskapp.com"
    }
  ];

  return (
    <section id="projects" className="w-full py-20 both border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>

      {/* Main Swiper Carousel */}
      <div className="w-full mt-10 px-6">
        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: true,
          }}
          navigation
          pagination={{ 
            clickable: true,
            dynamicBullets: true
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          loop={true}
          speed={1000}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
          className="pb-16"
        >
          {projects.map((project, index) => (
            <SwiperSlide key={index} className="max-w-sm mx-auto">
              <ProjectsCard
                title={project.title}
                des={project.des}
                src={project.src}
                github={project.github}
                live={project.live}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Projects;